export class HistoricoNotaFiscalEntradaDialogData {
  idNFeEntrada: number;
  /** Subtítulo do modal: "NF-e {numero} / {serie}". */
  titulo = '';
}
